import React from "react";
import { withRouter } from "react-router";
import { Translate } from "react-redux-i18n";
import { Link } from "react-router-dom";
import {
  FaUser,
  FaAddressCard,
  FaKey,
  FaUserShield,
  FaCog,
} from "react-icons/fa";

import "./styles/ProfileMenu.css";

const menuItems = [
  { to: "/profile", labelKey: "profile", icon: FaUser, exact: true },
  {
    to: "/profile/more_data",
    labelKey: "profile_data",
    icon: FaAddressCard,
    exact: false,
  },
  {
    to: "/profile/password",
    labelKey: "profile_change_password",
    icon: FaKey,
    exact: false,
  },
  {
    to: "/profile/privacy",
    labelKey: "profile_privacy",
    icon: FaUserShield,
    exact: false,
  },
  {
    to: "/profile/configuration",
    labelKey: "profile_configuration",
    icon: FaCog,
    exact: false,
  },
];

class ProfileMenu extends React.Component {
  isActive = (to, exact) => {
    const { pathname } = this.props.location;
    if (exact) return pathname === to;
    return pathname === to || pathname.startsWith(`${to}/`);
  };

  render() {
    return (
      <div className="container-profile-menu">
        <div className="card profile-menu-card">
          <nav className="profile-menu-nav" aria-label="Profile navigation">
            <span className="profile-menu-nav__header">
              <Translate value="profile" />
            </span>

            {menuItems.map(({ to, labelKey, icon: Icon, exact }) => (
              <Link
                key={to}
                to={to}
                className={`profile-menu-nav__link${
                  this.isActive(to, exact)
                    ? " profile-menu-nav__link--active"
                    : ""
                }`}
              >
                <Icon className="profile-menu-nav__icon" />
                <Translate value={labelKey} />
              </Link>
            ))}
          </nav>
        </div>
      </div>
    );
  }
}

export default withRouter(ProfileMenu);
